<template>
  <div>
    <v-row
      class="align-center justify-start mx-0"
      style="background-color:#f5f5f5; position:fixed; z-index: 10; min-width: -webkit-fill-available;"
    >
      <v-row>
        <v-col cols="5">
          <span
            class="text-start"
            style="color:#777; font-size:14px;"
          >DETALLE DEL STAND </span>
        </v-col>
        <v-spacer/>

        <v-col cols="1" style="min-width: fit-content;" class="pa-1">
          <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-35px;">
            <v-icon style="cursor: pointer; font-size:16px" @click="closeRightMenu">mdi-close</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-row>


    <!-- form  -->
    <v-container>
      <v-row class="row align-center justify-center pl-4 pr-4 pb-12" style="margin-top: -60px">
        <v-col cols="12">
          <v-form class ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" style="margin: 0 0 50px 0;margin-top: 90px">

                <v-row>
                  <p>{{editedQueue}}</p>
                </v-row>

                <hollow-dots-spinner
                  v-if="loading"
                  style="display: inline-block"
                  :animation-duration="2000"
                  :dot-size="15"
                  :dots-num="5"
                  :color="'#689840'"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <!-- /Add - cancel -->

      <div style="position: fixed; bottom: 0;background-color: white; width: 100%;">
        <v-divider style="mx-0"></v-divider>

        <v-row class="mb-2 pr-6">

          <v-col cols="6">
            <v-btn
              @click="loading ? false : closeRightMenu"
              class="justify-center"
              rounded
              depressed
              color="admiraGreen"
              small
              dark
              width="120"
            >Cerrar</v-btn>
          </v-col>

        </v-row>
      </div>
    </v-container>

    <!-- /form  -->
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "RightMenuStandDetail",
  data: () => ({
     typeQueueModel: "",
        types: [
          { type: 'Fila única', idType: 1 },
          { type: 'Fila única con tiquets', idType: 2 },
          { type: 'Fila multipuesto con tiquets', idType: 3 },
        ],
    allSpacesModel: "",
    isSaving: false,
    deleteDialog: false,
    show: true,
    showAlertStatus: false,
    showAlertPrintSize: false,
    addImage: false,
    photo: null,
    file: "",
    url: null,
    newImage: "",
    addImageName: "",
    addImageDes: "",
    loading: false,
    uploadSelected: 1,
    editDevice: false,
    upload: [{ title: "Subida Manual" }, { title: "Subida Masiva" }],
    statusEnable: [
      { name: "Creado", id: 0, color: "#acacac", type: 0 },
      { name: "Activo", id: 1, color: "#689840", type: 0 }
      //{ name: "Incidencia", id: 4, color: "#255c99", type: 1 }
    ],
    statusDisable: [
      { name: "Mantenimiento", id: 2, color: "#f6ae2d", type: 1 },
      { name: "Desinstalado", id: 3, color: "#fd846d", type: 2 }
    ],
    colorStatus: "#acacac",
    startDate: false,
    endDate: false,
    newStartDate: new Date().toISOString().substr(0, 10),

    // add device v-models
    valid: false,
    // deviceId: "1234",
    statusSelected: "Status",
    idMediaGroupSelected: "",
    objValues: "",

    //Select media group
    mediaTypeActive: true,
    arrMediaTypes: [],
    faceSizeActive: true,
    arrFaceSizes: [],
    printSizeActive: true,
    arrPrintSizes: [],
    showAlertMediaGroup: false,
    showAlertMediaType: false,
    showAlertFaceSize: false,
    showAlertNameDevice: false,
    labelMediaType: "Media Type *",
    labelFaceSize: "Resolución",
    labelPrintSize: "Tamaño",

    // Nuevo device desde soportes
    arrAllLocations: [],
    arrAllZones: [],
    zoneActive: true,
    nameZone: {}
  }),
  components: { HollowDotsSpinner },
  computed: {
    ...mapState("queues", [ "editedQueue","showRightMenu","objQueue", "allSpaces","asociatedSpaces"]),

  },
  methods: {

    ...mapMutations("queues", [
      "closeRightMenuMutation",
    ]),
    ...mapActions("queues", [
      "addQueueStore","getAsociatedResourcesStore","getAllQueues"
    ]),

    closeRightMenu() {      
      this.closeRightMenuMutation();
    }

  },
  created() {
    console.log(this.editedQueue);
    
  },
  mounted() {

  },
  destroyed() {
   
  }
};
</script>

<style scoped>
>>> .v-navigation-drawer {
  width: 418px !important;
}

.newtext {
  font-family: "Roboto", sans-serif;
}
a {
  text-decoration: none;
}
.admira-icon {
  font-family: "Admira icons";
}
.boxImage {
  background-color: #f5f5f5;
  height: 255px;
  padding: 110px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/RightMenuStandDetail.vue